import imageHover from '../modules/image-mouse-hover';
import { updateMenu } from '../modules/update-active-menu';
import { sliders } from '../modules/sliders';
import { setupPager } from '../modules/menu-pager';
import { makeResponsiveFrames } from '../modules/responsive-frames';
import { animateMultipageForms } from '../modules/multipage-forms';
import { accordians } from '../modules/accordion';
// import { measureFooter } from '../modules/measure-footer';
import { productFiltering } from '../modules/product-filtering';
import customFormFields from '../modules/wc-custom-form-fields';
// import { setupScrolling } from '../modules/scrolling';
import { watchForReveals } from '../modules/reveals';
import { footerBg, injectSvg } from '../modules/footer';
import { copyProductInfo } from '../modules/forms';
import { initModuleModals, unloadModuleModals } from '../modules/module-modals';
import ProductPage from '../modules/product-page';
import { initFilterAndSortModals, unloadFilterAndSortModals } from '../modules/filter-and-sort';
import ZendeskEmbed from '../modules/zendesk';

export default {
	init() {
		// JavaScript to be fired on all pages
		// setupScrolling();
		imageHover.init();
		animateMultipageForms.init();
		sliders.init();
		// measureFooter.init();
		productFiltering.init();
		customFormFields.init();

		accordians();
		initModuleModals();
		updateMenu();
		setupPager();
		makeResponsiveFrames();
		watchForReveals();
		footerBg();
		injectSvg();
		copyProductInfo();
		initFilterAndSortModals();

		ProductPage.init();

		console.log('init fired')
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		ZendeskEmbed.init();
	},
	cleanup() {
		// Cleanup functions
		sliders.unload();
		unloadModuleModals();
		// productFiltering.resetFilters();
		ProductPage.unload();
		unloadFilterAndSortModals();

		ZendeskEmbed.unload();

	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js